import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1b8b766"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = { class: "vrt-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "Enter Trailer Number", -1))
const _hoisted_4 = { class: "vrt-field" }
const _hoisted_5 = {
  key: 0,
  class: "vrt-field-hint"
}
const _hoisted_6 = { class: "vrt-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualRedTagHeader = _resolveComponent("VirtualRedTagHeader")!
  const _component_fbx_input = _resolveComponent("fbx-input")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VirtualRedTagHeader),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_fbx_input, {
          id: "vrt-trailer-number",
          label: "Trailer Number *",
          model: _ctx.trailerNumber,
          alert: _ctx.notFoundAlert,
          "onUpdate:modelValue": _ctx.onTrailerNumberChanged
        }, null, 8, ["model", "alert", "onUpdate:modelValue"]),
        (_ctx.isUnsupportedType)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.unsupportedTypeHint), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_fbx_button, {
          "button-text": "Continue",
          theme: "primary",
          disabled: !_ctx.canContinue,
          "show-loading": _ctx.isLoading,
          onClick: _ctx.onContinue
        }, null, 8, ["disabled", "show-loading", "onClick"]),
        _createVNode(_component_fbx_button, {
          "button-text": "Go Back",
          theme: "primaryOutline",
          class: "italic",
          onClick: _ctx.navigateBack
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}